import React, { useEffect, useState, ReactNode, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';

import './scss/capital-analysis.scss';
import SubTitle from '../component/sub-title';
import Color from '@/tool/color';

import Tab from '../component/tab';
import TimeTab from '../component/time-tab';
import moCapital, { changeDefalutDatas, changeModel, changeShowCapital, changeTab, changeTimeTab } from './store/capital-analysis';
import CapitalChart from './component/capital-chart';
import CommonTable from '../component/common-table';
import { BrowseIcon } from '@/styled/icon';
import moEffectPdf from '../store';
import { round } from 'mathjs';
import HeadTable from '../component/head-table';
import WorkService from '@/service/work';
import Empty from '@/component/empty';
import MainTitle from '../component/main-title';
import URI from 'urijs';
import Sub from '../component/sub';
import moMenu from '@/page/effect/store/menu';


interface IProps { }
interface IState { }

const CapitalAnalysis = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { capitalList } = moCapital;
  const uri = new URI(window.location.href);
  const path: any = uri.query(true);
  const result: any = decodeURIComponent(path.check);
  const data = JSON.parse(result);


  const emen: any = {
    人均营业收入: 'revenue_per_staff',
    人均净利润: 'profit_per_staff',
    元均营业收入: 'revenue_per_yuan',
    元均净利润: 'profit_per_yuan',
  };
  const getData = (val: string) => {
    const active = emen[val];
    let data: any = {
      red: 0,
      redRate: 0,
      yellow: 0,
      yellowRate: 0,
      blue: 0,
      blueRate: 0,
    };
    if (!isEmpty(capitalList)) {
      const list = capitalList?.chart_data[active];
      const redLength = list.filter((res: any) => res.flag === '红牌区').length;
      const yellowLength = list.filter((res: any) => res.flag === '警戒区').length;
      const blueLength = list.filter((res: any) => res.flag === '预期区').length;
      const rRate = redLength * 100 / (redLength + yellowLength + blueLength);
      const yRate = yellowLength * 100 / (redLength + yellowLength + blueLength);
      const bRate = blueLength * 100 / (redLength + yellowLength + blueLength);
      data = {
        red: redLength,
        redRate: rRate ? round(rRate, 1) : 0,
        yellow: yellowLength,
        yellowRate: yRate ? round(yRate, 1) : 0,
        blue: blueLength,
        blueRate: bRate ? round(bRate, 1) : 0,
      };
    }
    return data;
  };

  const myCompany = (val: string) => {
    let area = '';
    const active = emen[val];
    if (!isEmpty(capitalList?.chart_data)) {
      const list = capitalList?.chart_data[active]?.filter((res: any) => res.company_name === '您所在公司');
      area = !isEmpty(list) && list[0].flag;
    }
    return area;
  };

  useEffect(() => {
    return () => { };
  }, []);

  return (
    <section id="effect04" className="capital-analysis-warp-pdf human-common-pdf">
      <MainTitle
        title='人力资本回报分析'
        subtitle={moMenu.industryName}
        year={data.tabList.dt}
        bgcolor={Color.primaryColor(0.1)}
        color={Color.primary} />

      {data.tabList?.d1 && <section>
        <Sub title='人均营业收入' />
        <section className="chart-demo">
          {!isEmpty(capitalList?.chart_data) && !isEmpty(capitalList?.chart_data[emen['人均营业收入']]) ? <section className="chart">
            <CapitalChart activeTab='人均营业收入' />
          </section> : <Empty />}
        </section>
        {(!isEmpty(capitalList?.chart_data) && !isEmpty(capitalList?.chart_data[emen['人均营业收入']]) &&
          <section className="chart-detail capital-detail">
            <section className='item'>
              <b />
              <p >
                <span>
                  红牌区的公司有
                </span>
                <span className='t-red'>{getData('人均营业收入')?.red}</span>
                <span>家，占比</span>
                <span className='t-red'>{getData('人均营业收入')?.redRate}%</span>
              </p>
            </section>
            <section className='item'>
              <b />
              <p >
                <span>
                  警戒区的公司有
                </span>
                <span className='t-yellow'>{getData('人均营业收入')?.yellow}</span>
                <span>家，占比</span>
                <span className='t-yellow'>{getData('人均营业收入')?.yellowRate}%</span>
              </p>
            </section>
            <section className='item'>
              <b />
              <p >
                <span>
                  预期区的公司有
                </span>
                <span className='t-blue'>{getData('人均营业收入')?.blue}</span>
                <span>家，占比</span>
                <span className='t-blue'>{getData('人均营业收入')?.blueRate}%</span>
              </p>
            </section>
            {myCompany('人均营业收入') && <section className='item active'>
              <b />
              <p >
                <span>
                  您所在公司处于
                </span>
                <span >
                  {myCompany('人均营业收入')}
                </span>
                <span>
                  {myCompany('人均营业收入')}
                </span>
                <span >
                  {myCompany('人均营业收入')}
                </span>
              </p>
            </section>}
          </section>)}
      </section>}

      {data.tabList?.d2 && <section>
        <Sub title='人均净利润' />
        <section className="chart-demo">
          {!isEmpty(capitalList?.chart_data) && !isEmpty(capitalList?.chart_data[emen['人均净利润']]) ? <section className="chart">
            <CapitalChart activeTab='人均净利润' />
          </section> : <Empty />}
        </section>
        {(!isEmpty(capitalList?.chart_data) && !isEmpty(capitalList?.chart_data[emen['人均净利润']]) &&
          <section className="chart-detail capital-detail">
            <section className='item'>
              <b />
              <p >
                <span>
                  红牌区的公司有
                </span>
                <span className='t-red'>{getData('人均净利润')?.red}</span>
                <span>家，占比</span>
                <span className='t-red'>{getData('人均净利润')?.redRate}%</span>
              </p>
            </section>
            <section className='item'>
              <b />
              <p >
                <span>
                  警戒区的公司有
                </span>
                <span className='t-yellow'>{getData('人均净利润')?.yellow}</span>
                <span>家，占比</span>
                <span className='t-yellow'>{getData('人均净利润')?.yellowRate}%</span>
              </p>
            </section>
            <section className='item'>
              <b />
              <p >
                <span>
                  预期区的公司有
                </span>
                <span className='t-blue'>{getData('人均净利润')?.blue}</span>
                <span>家，占比</span>
                <span className='t-blue'>{getData('人均净利润')?.blueRate}%</span>
              </p>
            </section>
            {myCompany('人均净利润') && <section className='item active'>
              <b />
              <p >
                <span>
                  您所在公司处于
                </span>
                <span >
                  {myCompany('人均净利润')}
                </span>
                <span>
                  {myCompany('人均净利润')}
                </span>
                <span >
                  {myCompany('人均净利润')}
                </span>
              </p>
            </section>}
          </section>)}
      </section>}

      {data.tabList?.d3 && <section>
        <Sub title='元均净利润' />
        <section className="chart-demo">
          {!isEmpty(capitalList?.chart_data) && !isEmpty(capitalList?.chart_data[emen['元均净利润']]) ? <section className="chart">
            <CapitalChart activeTab='元均净利润' />
          </section> : <Empty />}
        </section>
        {(!isEmpty(capitalList?.chart_data) && !isEmpty(capitalList?.chart_data[emen['元均净利润']]) &&
          <section className="chart-detail capital-detail">
            <section className='item'>
              <b />
              <p >
                <span>
                  红牌区的公司有
                </span>
                <span className='t-red'>{getData('元均净利润')?.red}</span>
                <span>家，占比</span>
                <span className='t-red'>{getData('元均净利润')?.redRate}%</span>
              </p>
            </section>
            <section className='item'>
              <b />
              <p >
                <span>
                  警戒区的公司有
                </span>
                <span className='t-yellow'>{getData('元均净利润')?.yellow}</span>
                <span>家，占比</span>
                <span className='t-yellow'>{getData('元均净利润')?.yellowRate}%</span>
              </p>
            </section>
            <section className='item'>
              <b />
              <p >
                <span>
                  预期区的公司有
                </span>
                <span className='t-blue'>{getData('元均净利润')?.blue}</span>
                <span>家，占比</span>
                <span className='t-blue'>{getData('元均净利润')?.blueRate}%</span>
              </p>
            </section>
            {myCompany('元均净利润') && <section className='item active'>
              <b />
              <p >
                <span>
                  您所在公司处于
                </span>
                <span >
                  {myCompany('元均净利润')}
                </span>
                <span>
                  {myCompany('元均净利润')}
                </span>
                <span >
                  {myCompany('元均净利润')}
                </span>
              </p>
            </section>}
          </section>)}
      </section>}

      {data.tabList?.d4 && <section>
        <Sub title='元均营业收入' />
        <section className="chart-demo">
          {!isEmpty(capitalList?.chart_data) && !isEmpty(capitalList?.chart_data[emen['元均营业收入']]) ? <section className="chart">
            <CapitalChart activeTab='元均营业收入' />
          </section> : <Empty />}
        </section>
        {(!isEmpty(capitalList?.chart_data) && !isEmpty(capitalList?.chart_data[emen['元均营业收入']]) &&
          <section className="chart-detail capital-detail">
            <section className='item'>
              <b />
              <p >
                <span>
                  红牌区的公司有
                </span>
                <span className='t-red'>{getData('元均营业收入')?.red}</span>
                <span>家，占比</span>
                <span className='t-red'>{getData('元均营业收入')?.redRate}%</span>
              </p>
            </section>
            <section className='item'>
              <b />
              <p >
                <span>
                  警戒区的公司有
                </span>
                <span className='t-yellow'>{getData('元均营业收入')?.yellow}</span>
                <span>家，占比</span>
                <span className='t-yellow'>{getData('元均营业收入')?.yellowRate}%</span>
              </p>
            </section>
            <section className='item'>
              <b />
              <p >
                <span>
                  预期区的公司有
                </span>
                <span className='t-blue'>{getData('元均营业收入')?.blue}</span>
                <span>家，占比</span>
                <span className='t-blue'>{getData('元均营业收入')?.blueRate}%</span>
              </p>
            </section>
            {myCompany('元均营业收入') && <section className='item active'>
              <b />
              <p >
                <span>
                  您所在公司处于
                </span>
                <span >
                  {myCompany('元均营业收入')}
                </span>
                <span>
                  {myCompany('元均营业收入')}
                </span>
                <span >
                  {myCompany('元均营业收入')}
                </span>
              </p>
            </section>}
          </section>)}
      </section>}

    </section >
  );
};

export default observer(CapitalAnalysis);
